module.exports = __webpack_public_path__ + "static/media/17_before.0e6e57a0.jpg";